function registerUser() {
	jQuery(function($) {
		const $registrationForm = $('form#registration-form');
		let isValid = false;
		// Form Validation
		$registrationForm.validate({
			ignore: ':hidden',
			rules: {
				'email': {
					email: true
				},
				'user_pass_confirm': {
                    equalTo: '#user_pass'
                }
			},
			messages: {
				'user_fname': {
					required: 'Please enter your first name'
				},
				'user_email': {
					required: 'Please enter your email address',
					email: 'Please enter a valid email address'
				},
				'user_pass': {
					required: 'Please enter a password'
				},
				'user_pass_confirm': {
					required: 'Please re-enter your password',
					equalTo: 'Password don\'t match'
				}
			},
			focusInvalid: false,
			invalidHandler: function(form, validator) {
				if (!validator.numberOfInvalids()) {
					return;
				}

				$('html, body').animate({
					// Scroll to first error, add offset if there's a sticky header
					scrollTop: $(validator.errorList[0].element).offset().top - 0
				}, 500);
			}
		});

		// AJAX submit function
		$registrationForm.submit(function(e) {
			e.preventDefault();
			isValid = $registrationForm.valid();
			const data = new FormData($registrationForm[0]);

			// If form is valid, fire AJAX call
			if (isValid) {
				$.ajax({
					type: 'POST',
					dataType: 'json',
					url: '/wp-admin/admin-ajax.php',
					data: data,
					processData: false,
					contentType: false,
					dataType: 'json',
					success: function(data) {
						if (data.registered === true) {
							// Login success, redirect to homepage
							$('#ajax-register-status').removeClass('error').text(data.message);
							document.location.href = '/';
						} else {
							// Login failed, display error
							$('#ajax-register-status').addClass('error').text(data.message);
						}
					},
					error: function(request, status, error) {
						console.log(error);
					}
				});
			}
		});
	});
}

function loginUser() {
	jQuery(function($) {
		const $loginForm = $('form#login-form');
		let isValid = false;
		$loginForm.submit(function(e) {
			e.preventDefault();
			isValid = $loginForm.valid();
			const data = new FormData($loginForm[0]);
			$.ajax({
				type: 'POST',
				url: '/wp-admin/admin-ajax.php',
				data: data,
				processData: false,
				contentType: false,
				dataType: 'json',
				success: function(data) {
					if (data.loggedin === true) {
						// Login success, redirect to homepage
						$('#ajax-login-status').removeClass('error').text(data.message);
						document.location.href = '/';
					} else {
						// Login failed, display error
						$('#ajax-login-status').addClass('error').text(data.message);
					}
				},
				error: function(request, status, error) {
					console.log(error);
				}
			});
		});
	});
}

function loginRegisterHandler() {
	jQuery(function($) {
		registerUser();
		loginUser();

		// Toggle forms
		$('a.form-toggle').click(function(e) {
			e.preventDefault();
			$('.login-register__container > div').hide();
			if ($(this).hasClass('register')) {
				$('#register-cont').show();
			} else {
				$('#login-cont').show();
			}
		});

		// Logout
		$('button#user-logout').click(function(e) {
			e.preventDefault();
			$.ajax({
				type: 'POST',
				url: '/wp-admin/admin-ajax.php',
				data: {
					'action': 'logout_user'
				},
				success: function() {
					// Logout user and redirect to homepage
					document.location.href = '/';
				}
			});
		});
	});
}